import { Info } from '@phosphor-icons/react';

const TOOLTIPS = {
  // Role wizard
  requestable: "When enabled, users can request this role through the Access Request portal.",
  privileged: "Privileged roles require Just-in-Time (JIT) access — temporary, time-limited grants with mandatory approval.",
  assignment_duration: "How long a role assignment lasts before it expires. Users are reminded to renew before expiry.",
  entitlements: "Entitlements are the actual permissions (e.g., Azure AD groups) bundled into this role.",
  approval_workflow: "Define a sequential approval chain. Each step must be approved before moving to the next.",
  dynamic_role: "Dynamic roles auto-assign to identities matching attribute rules (e.g., department = Engineering).",

  // Page headers
  sod: "Separation of Duties prevents risky access combinations — e.g., one person shouldn't have both 'Create Invoices' and 'Approve Payments'.",
  certifications: "Periodic access reviews where managers or role owners verify that users still need their assigned access.",
  lifecycle: "Joiner/Mover/Leaver automations. Automatically assign or revoke roles when employees join, change teams, or leave.",
  role_mining: "AI-powered analysis of access patterns to suggest new roles, find over-provisioned users, and optimize entitlements.",
  jit_access: "Just-in-Time access grants temporary privileged roles (max 12 hours) that auto-revoke on expiry.",
  provisioning: "Manual provisioning tickets track access changes that can't be auto-provisioned (non-Azure systems).",

  // Other concepts
  orphaned: "Identities missing email, department, or manager. They cannot be assigned roles until the missing data is filled in.",
  entitlements_page: "Entitlements represent individual permissions — typically Azure AD groups or application-level access grants.",
  auto_assign: "Automatically assigns this role to identities matching department/job title rules when triggered.",
};

export default function InfoTooltip({ concept, className = '' }) {
  const text = TOOLTIPS[concept];
  if (!text) return null;

  return (
    <span className={`relative group inline-flex ${className}`}>
      <Info
        size={14}
        weight="regular"
        className="text-navy-400 hover:text-orange-500 cursor-help transition-colors shrink-0"
        data-testid={`info-tooltip-${concept}`}
      />
      <span className="pointer-events-none absolute left-1/2 -translate-x-1/2 top-full mt-2 w-72 px-4 py-3 rounded-lg bg-slate-900 text-white text-xs leading-relaxed shadow-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-150 z-[100]">
        <span className="absolute left-1/2 -translate-x-1/2 bottom-full w-0 h-0 border-l-[6px] border-r-[6px] border-b-[6px] border-transparent border-b-slate-900" />
        {text}
      </span>
    </span>
  );
}

export { TOOLTIPS };
